import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { toastr } from 'react-redux-toastr';
import { connect } from 'react-redux';
import { getCheckIfTicketExists } from '../../../../actions';
import Select from './Select';
import {
  inputDefaultProps,
  inputPropTypes,
  metaDefaultProps,
  metaPropTypes,
} from '../input/InputPropTypes';

const TicketBaggageSelect = ({
  dispatchGetCheckIfTicketExists,
  isMulti,
  input,
  meta,
  ...rest
}) => {
  const MIN_CODE_LENGTH = 3;

  const [isLoading, setIsLoading] = useState(false);

  const [options, setOptions] = useState([]);

  const onChange = async (inputValue) => {
    try {
      setOptions([]);
      setIsLoading(true);
      const value = inputValue.trim();
      if (!value.length) return;
      const ticket = value.split('-');
      if (ticket.length < 2) return;
      const documentCode = ticket[ticket.length - 1];
      const documentSerie = ticket.slice(0, -1).join('-');
      if (!documentSerie.length || documentCode.length <= MIN_CODE_LENGTH)
        return;

      const ticketExists = await dispatchGetCheckIfTicketExists({
        documentSeries: documentSerie,
        documentCode,
      });

      if (!ticketExists.exists) {
        setOptions([]);
        return;
      }

      const {
        ticketId,
        documentSeries,
        customerFullName,
        documentNumber,
        sourceLocation,
        destinationLocation,
        departureDate,
        customerId,
      } = ticketExists;

      const option = {
        value: ticketId,
        label: `${documentSeries}-${documentCode}`,
        customerFullName,
        customerDocumentNumber: documentNumber,
        sourceLocationName: sourceLocation,
        destinationLocationName: destinationLocation,
        departureDate,
        customerId,
        ...ticketExists,
      };

      setOptions([option]);
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Select
      options={options}
      onInputChange={onChange}
      isLoading={isLoading}
      isMulti={isMulti}
      input={input}
      meta={meta}
      {...rest}
    />
  );
};

TicketBaggageSelect.propTypes = {
  dispatchGetCheckIfTicketExists: PropTypes.func.isRequired,
  isMulti: PropTypes.bool,
  input: inputPropTypes,
  meta: metaPropTypes,
  loading: PropTypes.bool,
};

TicketBaggageSelect.defaultProps = {
  input: inputDefaultProps,
  meta: metaDefaultProps,
  loading: false,
  isMulti: false,
};

const mapDispatchToProps = {
  dispatchGetCheckIfTicketExists: getCheckIfTicketExists,
};

export default connect(null, mapDispatchToProps)(TicketBaggageSelect);
